/**
 * Hero Slider – dual Swiper instances (mobile + desktop tracks)
 * Waits for Swiper (loaded at end of body) before init.
 */
(function () {
  const SECTION_SELECTOR = '.hero-slider[data-section-id]';
  const MAX_WAIT_MS = 10000;

  function initSwiper(swiperEl, section) {
    const track = swiperEl.closest('.hero-slider__track');
    const autoplay = track
      ? track.dataset.autoplay === 'true'
      : section.dataset.autoplay === 'true';
    const speed = parseInt(
      track?.dataset.speed || section.dataset.speed || '5',
      10
    ) * 1000;
    const effect = section.dataset.effect || 'slide';

    return new Swiper(swiperEl, {
      loop: swiperEl.querySelectorAll('.swiper-slide').length > 1,
      speed: 600,
      effect: effect,
      fadeEffect: { crossFade: true },
      autoplay: autoplay
        ? {
            delay: speed,
            disableOnInteraction: false,
            pauseOnMouseEnter: true
          }
        : false,
      a11y: { enabled: true }
    });
  }

  function initHeroSlider(section) {
    if (section.dataset.heroInitialized === 'true') return;

    const swipers = section.querySelectorAll('.hero-slider__swiper');
    if (!swipers.length || typeof Swiper === 'undefined') return false;

    swipers.forEach((el) => {
      if (el.swiper) return;
      initSwiper(el, section);
    });

    section.dataset.heroInitialized = 'true';

    section.querySelectorAll('.hero-slider__image').forEach((img) => {
      if (img.complete) return;
      img.addEventListener(
        'load',
        () => {
          swipers.forEach((el) => el.swiper?.update());
        },
        { once: true }
      );
    });

    return true;
  }

  function updateAllSwipers() {
    document.querySelectorAll('.hero-slider__swiper').forEach((el) => {
      el.swiper?.update();
    });
  }

  let resizeTimer;
  function scheduleSwiperUpdate() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(updateAllSwipers, 150);
  }

  function initAll() {
    document.querySelectorAll(SECTION_SELECTOR).forEach((section) => {
      initHeroSlider(section);
    });
  }

  function watchBreakpoint() {
    const mq = window.matchMedia('(min-width: 750px)');
    const onChange = () => {
      requestAnimationFrame(scheduleSwiperUpdate);
    };
    if (typeof mq.addEventListener === 'function') {
      mq.addEventListener('change', onChange);
    } else {
      mq.addListener(onChange);
    }
  }

  function waitForSwiper(start) {
    if (typeof Swiper !== 'undefined') {
      initAll();
      return;
    }
    if (Date.now() - start > MAX_WAIT_MS) return;
    requestAnimationFrame(() => waitForSwiper(start));
  }

  function boot() {
    waitForSwiper(Date.now());
    watchBreakpoint();
    window.addEventListener('resize', scheduleSwiperUpdate, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const section =
      event.target.querySelector(SECTION_SELECTOR) ||
      event.target.closest(SECTION_SELECTOR);
    if (section) {
      section.dataset.heroInitialized = 'false';
      waitForSwiper(Date.now());
    }
  });
})();
